import { createClient } from "@supabase/supabase-js";
import authInstance from "data/firestore/auth";

// Supabase client bridged to Firebase Auth via third-party auth: every request
// carries the current Firebase ID token, and RLS reads the Firebase uid from
// auth.jwt()->>'sub'. No Supabase session/user is created here.
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL as string,
  process.env.REACT_APP_SUPABASE_ANON_KEY as string,
  {
    // supabase-js awaits this before EVERY request. Firebase's getIdToken()
    // can hang indefinitely after the WebView resumes from background (network
    // stack in limbo), which would wedge every query with no way to recover but
    // an app restart. Time it out so the request fails fast and can be retried.
    accessToken: async () => {
      const token = await Promise.race([
        authInstance.getIdToken(),
        // 15s to match the query monitor's timeout. The token is normally cached
        // and returns instantly; a long wait means either the network is wedged
        // (resume from background) or a token refresh is crawling on a slow/VPN
        // link. 5s was too tight for the latter -- it failed every request during
        // an hourly refresh on VPN. This still bounds the wedge case; the resume
        // reconnect + per-page retry are the real recovery.
        new Promise((_resolve, reject) =>
          setTimeout(() => reject(new Error("Auth token timeout")), 15000)
        ),
      ]);
      return (token as string | null) ?? null;
    },
  }
);
